module.exports = __webpack_public_path__ + "dash_20_app_assets/img/yelphow.6d59c069.png";